<template>
  <div :class='[{ "is-active": isOpen }, "modal"]'>
    <div class='modal-background'></div>
    <div class='modal-card'>
      <header class='modal-card-head'>
        <p class='modal-card-title'>Confirm Delete</p>
      </header>

      <section class='modal-card-body'>
        <slot>
          <p>Are you sure you want to delete?</p>
        </slot>
      </section>

      <footer class='modal-card-foot'>
        <button
          class='button is-danger'
          @click='$emit("confirm")'
        >
          Delete
        </button>

        <button
          class='button is-cancel'
          @click='$emit("cancel")'
        >
          Cancel
        </button>
      </footer>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DeleteConfirmation',

  props: {
    isOpen: {
      type: Boolean,
      required: true
    }
  }
}
</script>